<template>
	<div class="mt-2">
		<template v-if="loading">
			<v-progress-circular
				indeterminate
				color="primary"
				:size="40"
				width="2"
			></v-progress-circular>
		</template>
		<template v-else>
			<template v-if="settings == 'error'">
				Atsiprašome, šiuo metu nustatymai nepasiekiami...
			</template>
			<template v-else>
				<table>
					<template v-for="(setting, i) in settingsArray">
						<tr :key="i">
							<th>{{setting[0]}}</th>
							<td>{{setting[1]}}</td>
						</tr>
					</template>
				</table>
				<div class="mt-3">
					Atnaujinta: {{updateDate}}
				</div>
				<v-btn small class="pa-1 mt-4" v-on:click="editSettings">
					Redaguoti
				</v-btn>
			</template>
		</template>
		<CommonSettingsEditingForm />
	</div>
</template>

<script>
	import AdminHelper from "../helpers/AdminHelper";
	import CommonSettingsEditingForm from "./CommonSettingsEditingForm";

	export default {
		data: function(){
			var data = {
				loading: true,
				settings: null,
				updateDate: null
			};
			return data;
		},
		components: {
			CommonSettingsEditingForm
		},
		created(){
			this.getSettings();
		},
		methods: {
			getSettings: function(){
				this.loading = true;
				AdminHelper.getCommonSettings().then(function(data){
					this.loading = false;
					var settingsArray = [];
					if (data) {
						for (var key in data.settings) {
							settingsArray.push([AdminHelper.getAttributeTitle(key), data.settings[key]]);
						}
						this.settings = data.settings;
						this.updateDate = data.updateDate;
					}
					this.settingsArray = settingsArray;
				}.bind(this), function(){
					this.loading = false;
					this.settings = "error";
				}.bind(this));
			},
			editSettings: function(){
				var e = {
					settings: this.settings,
					callback: function(){
						this.getSettings();
					}.bind(this)
				};
				this.$vBus.$emit("show-admin-settings-editing-form", e);
			}
		}
	};
</script>

<style scoped>
	table {
		border-collapse: collapse;
	}
	td, th {
		border: 1px solid #cccccc;
		padding: 7px;
	}
	th {
		text-align: left;
	}
</style>